import { WorkShiftType } from '@tymbe/legislatives/WorkShiftType';

export const workShiftTypeNameMap: Record<WorkShiftType, string> = {
  [WorkShiftType.Regular]: 'Směna',
  [WorkShiftType.Vacation]: 'Dovolená',
}
